/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Hero_Cta_SecondaryInputs */

const en_mk_hero_cta_secondary = /** @type {(inputs: Mk_Hero_Cta_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See how it works`)
};

const id_mk_hero_cta_secondary = /** @type {(inputs: Mk_Hero_Cta_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat cara kerja`)
};

/**
* | output |
* | --- |
* | "See how it works" |
*
* @param {Mk_Hero_Cta_SecondaryInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_hero_cta_secondary = /** @type {((inputs?: Mk_Hero_Cta_SecondaryInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Hero_Cta_SecondaryInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_hero_cta_secondary(inputs)
	return en_mk_hero_cta_secondary(inputs)
});